import { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { Chart, registerables } from 'chart.js';
import { orderService } from '../services/api';
import { useAuth } from '../context/AuthContext';
import axios2 from 'axios';
import * as XLSX from 'xlsx';
import Navbar from './Navbar';
Chart.register(...registerables);

const fmt = n => '₡' + Number(n).toLocaleString('es-CR');
const fmtFecha = f => { if (!f) return '—'; const d = f.split('T')[0].split('-'); return `${parseInt(d[2])}-${parseInt(d[1])}-${d[0]}`; };
const hoy = new Date().toLocaleDateString('en-CA');
const inicioMes = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toLocaleDateString('en-CA');

const getLunesDeSemana = (offset = 0) => {
  const d = new Date();
  const day = d.getDay();
  const diff = (day === 0 ? -6 : 1 - day) + offset * 7;
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return d.toLocaleDateString('en-CA');
};

const getDomingo = (lunes) => {
  const d = new Date(lunes);
  d.setDate(d.getDate() + 6);
  return d.toLocaleDateString('en-CA');
};

const VENDEDORES = [
  { username: 'fperez',  nombre: 'Felix Pérez' },
  { username: 'pperez',  nombre: 'Pablo Pérez' },
  { username: 'aduran',  nombre: 'Ana Yanci Brenes Durán' },
  { username: 'ssoto',   nombre: 'Silvia Soto' },
  { username: 'ltorres', nombre: 'Laura Torres' },
  { username: 'kbrenes', nombre: 'Karen Brenes' },
  { username: 'emendez', nombre: 'Eliecer Mendez' },
  { username: 'mdiaz', nombre: 'Melania Diaz' },
  { username: 'delizondo', nombre: 'Daniela Elizondo Segura' },
];

export default function Reports() {
  const [periodo, setPeriodo] = useState('mes');
  const [desde, setDesde] = useState(inicioMes);
  const [hasta, setHasta] = useState(hoy);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [allOrders, setAllOrders] = useState([]);
  const [semanaOffset, setSemanaOffset] = useState(0);
  const [vendedorSeleccionado, setVendedorSeleccionado] = useState(null);
  const { user } = useAuth();
  const [comisiones, setComisiones] = useState({});
  const esJefe = user && (user.id === 2 || user.id === 3);
  const toggleComision = async (orderId) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios2.patch(`/api/orders/${orderId}/comision`, {}, { headers: { Authorization: `Bearer ${token}` } });
      setComisiones(prev => ({ ...prev, [orderId]: { pagada: res.data.comision_pagada, fecha: res.data.comision_pagada_fecha, por: res.data.comision_pagada_por } }));
    } catch (e) { alert(e.response?.data?.error || 'Error al marcar comisión'); }
  };
  const estaComisionPagada = (o) => comisiones[o.id] !== undefined ? comisiones[o.id].pagada : o.comision_pagada;
  const fechaComision = (o) => comisiones[o.id] !== undefined ? comisiones[o.id].fecha : o.comision_pagada_fecha;
  const chart1Ref = useRef(null);
  const chart2Ref = useRef(null);
  const chart1Instance = useRef(null);
  const chart2Instance = useRef(null);

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const lunes = getLunesDeSemana(semanaOffset);
  const domingo = getDomingo(lunes);

  const fetchData = useCallback(async (d, h) => {
    setLoading(true);
    try {
      const res = await axios.get(`/api/reports?desde=${d}&hasta=${h}`, { headers });
      setData(res.data);
    } catch (err) { console.error(err); }
    setLoading(false);
  }, []);

  useEffect(() => {
    orderService.getAll('').then(res => setAllOrders(res.data)).catch(() => {});
  }, []);

  useEffect(() => { fetchData(desde, hasta); }, []);

  useEffect(() => {
    if (!data) return;
    if (chart1Instance.current) chart1Instance.current.destroy();
    if (chart2Instance.current) chart2Instance.current.destroy();

    if (chart1Ref.current) {
      chart1Instance.current = new Chart(chart1Ref.current, {
        type: 'bar',
        data: {
          labels: data.vendedores.map(v => v.vendedor),
          datasets: [{ data: data.vendedores.map(v => Number(v.total)), backgroundColor: '#5c3d2e', borderRadius: 4 }]
        },
        options: {
          responsive: true, maintainAspectRatio: false,
          plugins: { legend: { display: false } },
          scales: {
            x: { grid: { display: false }, ticks: { font: { size: 11 } } },
            y: { grid: { color: 'rgba(0,0,0,0.05)' }, ticks: { font: { size: 11 }, callback: v => '₡' + (v/1000000).toFixed(1) + 'M' } }
          }
        }
      });
    }

    if (chart2Ref.current) {
      chart2Instance.current = new Chart(chart2Ref.current, {
        type: 'bar',
        data: {
          labels: data.productos.map(p => p.article.length > 20 ? p.article.substring(0,20)+'...' : p.article),
          datasets: [{ data: data.productos.map(p => Number(p.cantidad)), backgroundColor: '#a0522d', borderRadius: 4 }]
        },
        options: {
          indexAxis: 'y',
          responsive: true, maintainAspectRatio: false,
          plugins: { legend: { display: false } },
          scales: {
            x: { grid: { color: 'rgba(0,0,0,0.05)' }, ticks: { font: { size: 11 } } },
            y: { grid: { display: false }, ticks: { font: { size: 11 } } }
          }
        }
      });
    }
  }, [data]);

  const handlePeriodo = (p) => {
    setPeriodo(p);
    let d = inicioMes, h = hoy;
    if (p === 'mes') { d = inicioMes; h = hoy; }
    setDesde(d); setHasta(h);
    if (p !== 'personalizado') fetchData(d, h);
  };

  const getOrdenesVendedor = (nombreVendedor) => {
    // Felix Pérez incluye también las órdenes de Oficina Central (él las maneja)
    const nombresIncluidos = nombreVendedor === 'Felix Pérez'
      ? ['Felix Pérez', 'Oficina Central']
      : [nombreVendedor];
    return allOrders.filter(o => {
      if (o.status !== 'Entregada') return false;
      if (!nombresIncluidos.includes(o.vendedor)) return false;
      const fecha = o.delivery_date?.split('T')[0];
      if (!fecha) return false;
      return fecha >= lunes && fecha <= domingo;
    });
  };

  const exportarExcel = (v) => {
    const ordenes = getOrdenesVendedor(v.nombre);
    const total = ordenes.reduce((s, o) => s + Number(o.amount) + Number(o.shipping), 0);

    // Encabezado informativo
    const encabezado = [
      ['Muebles Terrasol — Reporte de Ventas'],
      [`Vendedor: ${v.nombre}`],
      [`Período: ${fmtFecha(lunes)} al ${fmtFecha(domingo)}`],
      [`Generado: ${fmtFecha(hoy)}`],
      [],
    ];

    // Columnas
    const columnas = [['N° Orden', 'Fecha Entrega', 'Cliente', 'Artículo', 'Total (₡)']];

    // Filas de datos
    const filas = ordenes.map(o => [
      o.numero,
      fmtFecha(o.delivery_date),
      o.cliente_nombre || o.nombre || '—',
      o.article || '—',
      Number(o.amount) + Number(o.shipping),
    ]);

    // Fila de total
    const filaTotales = [
      [],
      [`Total órdenes: ${ordenes.length}`, '', '', 'TOTAL', total],
    ];

    const wsData = [...encabezado, ...columnas, ...filas, ...filaTotales];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Ancho de columnas
    ws['!cols'] = [
      { wch: 14 },
      { wch: 14 },
      { wch: 30 },
      { wch: 35 },
      { wch: 16 },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, v.nombre.substring(0, 31));

    const nombreArchivo = `Ventas_${v.nombre.replace(/ /g, '_')}_${lunes}_${domingo}.xlsx`;
    XLSX.writeFile(wb, nombreArchivo);
  };

  const imprimirVendedor = (v) => {
    const ordenes = getOrdenesVendedor(v.nombre);
    const total = ordenes.reduce((s, o) => s + Number(o.amount) + Number(o.shipping), 0);
    const filas = ordenes.map(o => `
      <tr>
        <td style="padding:8px 10px;border-bottom:1px solid #f0e8e0;font-weight:600;color:#a0522d">${o.numero}</td>
        <td style="padding:8px 10px;border-bottom:1px solid #f0e8e0">${o.cliente_nombre || o.nombre || '—'}</td>
        <td style="padding:8px 10px;border-bottom:1px solid #f0e8e0">${o.article || '—'}</td>
        <td style="padding:8px 10px;border-bottom:1px solid #f0e8e0;text-align:center">${fmtFecha(o.delivery_date)}</td>
        <td style="padding:8px 10px;border-bottom:1px solid #f0e8e0;text-align:right;font-weight:700;color:#10b981">₡${Number(Number(o.amount)+Number(o.shipping)).toLocaleString('es-CR')}</td>
      </tr>
    `).join('');

    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8">
    <title>Reporte ${v.nombre}</title>
    <style>
      body{font-family:Arial,sans-serif;padding:30px;color:#1f2937;}
      .header{border-bottom:3px solid #5c3d2e;padding-bottom:14px;margin-bottom:20px;display:flex;justify-content:space-between;align-items:flex-end;}
      .titulo{font-size:20px;font-weight:800;color:#5c3d2e;}
      .subtitulo{font-size:13px;color:#888;margin-top:4px;}
      .semana{font-size:13px;color:#5c3d2e;font-weight:600;text-align:right;}
      table{width:100%;border-collapse:collapse;}
      th{background:#f5ede6;padding:9px 10px;text-align:left;color:#5c3d2e;font-weight:700;border-bottom:2px solid #e0d0c0;font-size:12px;}
      .total-row td{background:#5c3d2e;color:#fff;font-weight:700;padding:10px;}
      .resumen{background:#f0ebe5;border-radius:8px;padding:12px 16px;margin-bottom:20px;display:flex;gap:40px;}
      .res-item{font-size:13px;color:#5c3d2e;}
      .res-item strong{font-size:20px;display:block;font-weight:800;}
      .sin-ordenes{text-align:center;color:#aaa;padding:30px;font-size:14px;}
    </style>
    </head><body>
    <div class="header">
      <div>
        <div class="titulo">Muebles Terrasol</div>
        <div class="subtitulo">Reporte de ventas — ${v.nombre}</div>
      </div>
      <div class="semana">Semana del<br/>${fmtFecha(lunes)} al ${fmtFecha(domingo)}</div>
    </div>
    <div class="resumen">
      <div class="res-item"><strong>${ordenes.length}</strong>Órdenes entregadas</div>
      <div class="res-item"><strong>₡${Number(total).toLocaleString('es-CR')}</strong>Total vendido</div>
    </div>
    ${ordenes.length === 0
      ? '<div class="sin-ordenes">No hay órdenes entregadas en esta semana</div>'
      : `<table>
          <thead><tr>
            <th>N° Orden</th><th>Cliente</th><th>Artículo</th>
            <th style="text-align:center">F. Entrega</th>
            <th style="text-align:right">Total</th>
          </tr></thead>
          <tbody>
            ${filas}
            <tr class="total-row">
              <td colspan="4">TOTAL — ${ordenes.length} orden${ordenes.length !== 1 ? 'es' : ''}</td>
              <td style="text-align:right">₡${Number(total).toLocaleString('es-CR')}</td>
            </tr>
          </tbody>
        </table>`
    }
    <script>window.onload = () => window.print();</script>
    </body></html>`;

    const win = window.open('', '_blank');
    win.document.write(html);
    win.document.close();
  };

  const s = {
    page: { padding: '24px', maxWidth: 1100, margin: '0 auto' },
    title: { fontSize: 24, fontWeight: 700, color: '#5c3d2e', marginBottom: 20 },
    filters: { display: 'flex', gap: 8, marginBottom: 24, flexWrap: 'wrap', alignItems: 'center' },
    filterBtn: (active) => ({ background: active ? '#5c3d2e' : '#f0ebe5', color: active ? '#fff' : '#5c3d2e', border: 'none', padding: '6px 16px', borderRadius: 20, cursor: 'pointer', fontSize: 13, fontWeight: active ? 600 : 400 }),
    metrics: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 12, marginBottom: 24 },
    metric: { background: '#f0ebe5', borderRadius: 10, padding: '1rem' },
    metricLabel: { fontSize: 12, color: '#888', marginBottom: 6 },
    metricValue: { fontSize: 22, fontWeight: 600, color: '#5c3d2e' },
    grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 },
    card: { background: '#fff', border: '0.5px solid #e5e7eb', borderRadius: 12, padding: '1rem 1.25rem', marginBottom: 16 },
    cardTitle: { fontSize: 14, fontWeight: 600, color: '#5c3d2e', marginBottom: 12 },
    th: { textAlign: 'left', padding: '8px 10px', color: '#888', fontWeight: 500, borderBottom: '0.5px solid #e5e7eb', fontSize: 12 },
    td: { padding: '8px 10px', borderBottom: '0.5px solid #f3f4f6', fontSize: 13 },
  };

  return (
    <>
    <Navbar />
    <div style={s.page}>
      <div style={s.title}>📈 Reportes</div>

      {/* REPORTE SEMANAL POR VENDEDOR */}
      <div style={{ ...s.card, border: '2px solid #5c3d2e', marginBottom: 28 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16, flexWrap:'wrap', gap:10 }}>
          <div>
            <div style={{ fontSize:16, fontWeight:700, color:'#5c3d2e' }}>📋 Reporte Semanal por Vendedor</div>
            <div style={{ fontSize:12, color:'#888', marginTop:2 }}>Solo órdenes en estado <strong>Entregada</strong> dentro de la semana seleccionada</div>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            <button onClick={() => { setSemanaOffset(o => o - 1); setVendedorSeleccionado(null); }}
              style={{ background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'6px 14px', borderRadius:6, cursor:'pointer', fontSize:18, fontWeight:700 }}>‹</button>
            <div style={{ textAlign:'center', minWidth:180 }}>
              <div style={{ fontSize:13, fontWeight:700, color:'#5c3d2e' }}>{fmtFecha(lunes)} — {fmtFecha(domingo)}</div>
              <div style={{ fontSize:11, color:'#aaa' }}>
                {semanaOffset === 0 ? 'Semana actual' : semanaOffset === -1 ? 'Semana pasada' : `Hace ${Math.abs(semanaOffset)} semanas`}
              </div>
            </div>
            <button onClick={() => { setSemanaOffset(o => Math.min(o + 1, 0)); setVendedorSeleccionado(null); }}
              disabled={semanaOffset >= 0}
              style={{ background: semanaOffset >= 0 ? '#eee' : '#f0ebe5', color: semanaOffset >= 0 ? '#ccc' : '#5c3d2e', border:'none', padding:'6px 14px', borderRadius:6, cursor: semanaOffset >= 0 ? 'not-allowed' : 'pointer', fontSize:18, fontWeight:700 }}>›</button>
            {semanaOffset !== 0 && (
              <button onClick={() => { setSemanaOffset(0); setVendedorSeleccionado(null); }}
                style={{ background:'#f0ebe5', color:'#5c3d2e', border:'1px solid #d0b89a', padding:'5px 10px', borderRadius:6, cursor:'pointer', fontSize:11 }}>Semana actual</button>
            )}
          </div>
        </div>

        {/* Tarjetas por vendedor */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(190px, 1fr))', gap:10, marginBottom: vendedorSeleccionado ? 16 : 0 }}>
          {VENDEDORES.map(v => {
            const ordenes = getOrdenesVendedor(v.nombre);
            const total = ordenes.reduce((s, o) => s + Number(o.amount) + Number(o.shipping), 0);
            const activo = vendedorSeleccionado === v.username;
            return (
              <div key={v.username} style={{ background: activo ? '#5c3d2e' : '#fdf8f4', border: `2px solid ${activo ? '#5c3d2e' : '#e8ddd4'}`, borderRadius:10, padding:'14px 16px', transition:'all 0.2s' }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:6 }}>
                  <div>
                    <div style={{ fontWeight:700, fontSize:14, color: activo ? '#fff' : '#5c3d2e' }}>{v.nombre}</div>
                    <div style={{ fontSize:11, color: activo ? 'rgba(255,255,255,0.6)' : '#aaa', marginTop:1 }}>{v.username}</div>
                  </div>
                  <span style={{ background: ordenes.length > 0 ? '#10b981' : '#d1d5db', color:'#fff', borderRadius:20, padding:'2px 8px', fontSize:12, fontWeight:700 }}>{ordenes.length}</span>
                </div>
                <div style={{ fontSize:14, fontWeight:800, color: activo ? '#6ee7b7' : '#10b981', marginBottom:10 }}>{fmt(total)}</div>
                <div style={{ display:'flex', gap:4, flexWrap:'wrap' }}>
                  <button onClick={() => setVendedorSeleccionado(activo ? null : v.username)}
                    style={{ flex:1, background: activo ? 'rgba(255,255,255,0.15)' : '#f0ebe5', color: activo ? '#fff' : '#5c3d2e', border:'none', padding:'6px 0', borderRadius:6, cursor:'pointer', fontSize:11, fontWeight:600 }}>
                    {activo ? '▲ Ocultar' : '👁 Ver'}
                  </button>
                  <button onClick={() => imprimirVendedor(v)}
                    style={{ flex:1, background: activo ? '#fff' : '#5c3d2e', color: activo ? '#5c3d2e' : '#fff', border:'none', padding:'6px 0', borderRadius:6, cursor:'pointer', fontSize:11, fontWeight:600 }}>
                    🖨️ PDF
                  </button>
                  <button onClick={() => exportarExcel(v)}
                    style={{ flex:1, background:'#16a34a', color:'#fff', border:'none', padding:'6px 0', borderRadius:6, cursor:'pointer', fontSize:11, fontWeight:600 }}>
                    📊 Excel
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        {/* Detalle expandido del vendedor */}
        {vendedorSeleccionado && (() => {
          const v = VENDEDORES.find(v => v.username === vendedorSeleccionado);
          const ordenes = getOrdenesVendedor(v.nombre);
          const total = ordenes.reduce((s, o) => s + Number(o.amount) + Number(o.shipping), 0);
          return (
            <div style={{ borderTop:'2px solid #e8ddd4', paddingTop:16, marginTop:4 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
                <div style={{ fontWeight:700, fontSize:14, color:'#5c3d2e' }}>
                  Órdenes de {v.nombre} — {fmtFecha(lunes)} al {fmtFecha(domingo)}
                </div>
                <span style={{ background:'#10b981', color:'#fff', borderRadius:20, padding:'3px 12px', fontSize:12, fontWeight:700 }}>
                  {fmt(total)}
                </span>
              </div>
              {ordenes.length === 0
                ? <div style={{ textAlign:'center', color:'#aaa', padding:24, fontSize:14 }}>No hay órdenes entregadas esta semana</div>
                : <div style={{ overflowX:'auto' }}>
                    <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
                      <thead>
                        <tr>
                          <th style={s.th}>N° Orden</th>
                          <th style={s.th}>Cliente</th>
                          <th style={s.th}>Artículo</th>
                          <th style={s.th}>F. Entrega</th>
                          <th style={{ ...s.th, textAlign:'right' }}>Total</th>
                          {esJefe && <th style={{ ...s.th, textAlign:'center' }}>Comisión</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {ordenes.map((o, i) => {
                          const pagada = estaComisionPagada(o);
                          return (
                          <tr key={i} style={{ background: pagada ? '#e8f7ec' : (i % 2 === 0 ? '#fff' : '#fdf8f4') }}>
                            <td style={{ ...s.td, fontWeight:600, color:'#a0522d' }}>{o.numero}</td>
                            <td style={s.td}>{o.cliente_nombre || o.nombre || '—'}</td>
                            <td style={s.td}>{o.article || '—'}</td>
                            <td style={s.td}>{fmtFecha(o.delivery_date)}</td>
                            <td style={{ ...s.td, textAlign:'right', fontWeight:700, color: pagada ? '#3a7d44' : '#10b981' }}>{fmt(Number(o.amount)+Number(o.shipping))}</td>
                            {esJefe && (
                              <td style={{ ...s.td, textAlign:'center' }}>
                                <button onClick={()=>toggleComision(o.id)}
                                  style={{ background: pagada ? '#3a7d44' : '#f0ebe5', color: pagada ? '#fff' : '#5c3d2e', border:'none', borderRadius:6, padding:'4px 10px', fontSize:11, fontWeight:600, cursor:'pointer' }}>
                                  {pagada ? '✓ Pagada' : 'Marcar'}
                                </button>
                                {pagada && fechaComision(o) && <div style={{ fontSize:10, color:'#888', marginTop:2 }}>{fmtFecha(fechaComision(o))}</div>}
                              </td>
                            )}
                          </tr>
                          );
                        })}
                        <tr style={{ background:'#5c3d2e' }}>
                          <td colSpan={3} style={{ ...s.td, color:'#fff', fontWeight:700 }}>TOTAL — {ordenes.length} orden{ordenes.length !== 1 ? 'es' : ''}</td>
                          <td style={{ ...s.td, color:'#fff' }}></td>
                          <td style={{ ...s.td, textAlign:'right', color:'#fff', fontWeight:800, fontSize:15 }}>{fmt(total)}</td>
                          {esJefe && <td style={{ ...s.td }}></td>}
                        </tr>
                      </tbody>
                    </table>
                  </div>
              }
            </div>
          );
        })()}
      </div>

      {/* FILTROS GENERALES */}
      <div style={s.filters}>
        <span style={{ fontSize: 13, color: '#888', marginRight: 4 }}>Período general:</span>
        {[['mes','Este mes'],['personalizado','Personalizado']].map(([k,l]) => (
          <button key={k} style={s.filterBtn(periodo===k)} onClick={() => handlePeriodo(k)}>{l}</button>
        ))}
        {periodo === 'personalizado' && (
          <>
            <input type="date" value={desde} onChange={e => setDesde(e.target.value)} style={{ fontSize: 13, padding: '4px 8px', borderRadius: 6, border: '1px solid #ddd' }} />
            <span style={{ fontSize: 13, color: '#888' }}>—</span>
            <input type="date" value={hasta} onChange={e => setHasta(e.target.value)} style={{ fontSize: 13, padding: '4px 8px', borderRadius: 6, border: '1px solid #ddd' }} />
            <button style={s.filterBtn(true)} onClick={() => fetchData(desde, hasta)}>Consultar</button>
          </>
        )}
      </div>

      {loading && <div style={{ textAlign: 'center', padding: 40, color: '#888' }}>Cargando reportes...</div>}

      {!loading && data && <>
        <div style={s.metrics}>
          <div style={s.metric}><div style={s.metricLabel}>Total órdenes</div><div style={s.metricValue}>{data.resumen.total_ordenes}</div></div>
          <div style={s.metric}><div style={s.metricLabel}>Total cobrado</div><div style={s.metricValue}>{fmt(data.resumen.total_cobrado)}</div></div>
          <div style={s.metric}><div style={s.metricLabel}>Ticket promedio</div><div style={s.metricValue}>{fmt(Math.round(data.resumen.ticket_promedio))}</div></div>
          <div style={{ ...s.metric, background: data.resumen.atrasadas > 0 ? '#fee2e2' : '#f0ebe5' }}>
            <div style={s.metricLabel}>Atrasadas</div>
            <div style={{ ...s.metricValue, color: data.resumen.atrasadas > 0 ? '#dc2626' : '#5c3d2e' }}>{data.resumen.atrasadas}</div>
          </div>
        </div>

        <div style={s.grid2}>
          <div style={s.card}>
            <div style={s.cardTitle}>Ventas por vendedor</div>
            <div style={{ position: 'relative', height: 220 }}><canvas ref={chart1Ref}></canvas></div>
          </div>
          <div style={s.card}>
            <div style={s.cardTitle}>Productos más vendidos</div>
            <div style={{ position: 'relative', height: 220 }}><canvas ref={chart2Ref}></canvas></div>
          </div>
        </div>

        <div style={s.grid2}>
          <div style={s.card}>
            <div style={s.cardTitle}>Clientes frecuentes</div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr><th style={s.th}>Cliente</th><th style={s.th}>Órdenes</th><th style={s.th}>Total</th></tr></thead>
              <tbody>
                {data.clientes.map((c,i) => (
                  <tr key={i}><td style={s.td}>{c.cliente}</td><td style={s.td}>{c.ordenes}</td><td style={s.td}>{fmt(c.total)}</td></tr>
                ))}
                {data.clientes.length === 0 && <tr><td colSpan={3} style={{ ...s.td, color: '#aaa', textAlign: 'center' }}>Sin datos</td></tr>}
              </tbody>
            </table>
          </div>
          <div style={s.card}>
            <div style={s.cardTitle}>Producción por fabricante</div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr><th style={s.th}>Fabricante</th><th style={s.th}>Órdenes</th><th style={s.th}>Estado</th></tr></thead>
              <tbody>
                {data.fabricantes.map((f,i) => (
                  <tr key={i}>
                    <td style={s.td}>{f.fabricante}</td>
                    <td style={s.td}>{f.ordenes}</td>
                    <td style={s.td}>
                      {f.atrasadas > 0
                        ? <span style={{ background: '#fee2e2', color: '#991b1b', padding: '2px 8px', borderRadius: 12, fontSize: 11 }}>{f.atrasadas} atrasada{f.atrasadas>1?'s':''}</span>
                        : <span style={{ background: '#dcfce7', color: '#166534', padding: '2px 8px', borderRadius: 12, fontSize: 11 }}>Al día</span>}
                    </td>
                  </tr>
                ))}
                {data.fabricantes.length === 0 && <tr><td colSpan={3} style={{ ...s.td, color: '#aaa', textAlign: 'center' }}>Sin datos</td></tr>}
              </tbody>
            </table>
          </div>
        </div>

        {data.atrasadas.length > 0 && (
          <div style={s.card}>
            <div style={s.cardTitle}>Órdenes atrasadas</div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr>
                <th style={s.th}>N° Orden</th><th style={s.th}>Cliente</th><th style={s.th}>Artículo</th>
                <th style={s.th}>F. Entrega</th><th style={s.th}>Días retraso</th><th style={s.th}>Vendedor</th>
              </tr></thead>
              <tbody>
                {data.atrasadas.map((o,i) => (
                  <tr key={i} style={{ background: '#fff5f5', borderLeft: '3px solid #dc2626' }}>
                    <td style={{ ...s.td, color: '#a0522d', fontWeight: 600 }}>{o.numero}</td>
                    <td style={s.td}>{o.cliente}</td>
                    <td style={s.td}>{o.article}</td>
                    <td style={s.td}>{fmtFecha(o.delivery_date)}</td>
                    <td style={s.td}><span style={{ background: '#fee2e2', color: '#991b1b', padding: '2px 8px', borderRadius: 12, fontSize: 11 }}>{o.dias_retraso} día{o.dias_retraso>1?'s':''}</span></td>
                    <td style={s.td}>{o.vendedor}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </>}
    </div>
    </>
  );
}
